import apiSlice from "./apiSlice";

const safetyDashboardSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSafetyKpis: builder.query({
      query: ({ projectId }) => ({
        url: `safety/dashboard/kpis`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["SafetyKpis"],
    }),

    getMonthlyManhours: builder.query({
      query: ({ projectId, year }) => ({
        url: `safety/manhours/monthly`,
        params: { projectId, year },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["MonthlyManhours"],
    }),

    getMonthlyNearMiss: builder.query({
      query: ({ projectId, year }) => ({
        url: `safety/monthly-near-miss`,
        params: { projectId, year },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["MonthlyNearMiss"],
    }),

    getOpenCloseNcrSummary: builder.query({
      query: ({ projectId }) => ({
        url: `safety/ncr/open-close-summary`,
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["OpenCloseNcrSummary"],
    }),

    getMonthlyFatalities: builder.query({
      query: ({ projectId, year }) => ({
        url: `safety/kpi/monthly-fatalities`,
        params: { projectId, year },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["MonthlyFatalities"],
    }),
     getMonthlyLtis: builder.query({
      query: ({ projectId, year }) => ({
        url: `safety/kpi/monthly-ltis`,
        params: { projectId, year },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["MonthlyLtis"],
    }),
  }),
});

export const {
  useGetSafetyKpisQuery,
  useGetMonthlyManhoursQuery,
  useGetMonthlyNearMissQuery,
  useGetOpenCloseNcrSummaryQuery,
  useGetMonthlyFatalitiesQuery,
  useGetMonthlyLtisQuery,
} = safetyDashboardSlice;

export default safetyDashboardSlice;
